/*
 * @Description: 城市添加合作商（个别城市）
 * @Version: 2.0
 * @Author: zhouhong07
 * @Date: 2020-03-06 16:40:25
 * @LastEditors: zhouhong07
 * @LastEditTime: 2020-03-24 18:51:13
 */
const cityName = [
  {
    name : "乐清" ,
    intro : "乐清市人社局"
  },
  {
    name : "厦门" ,
    intro : "厦门思明区人社局"
  },
  {
    name : "自贡" ,
    intro : "自贡市就业局"
  },
  {
    name : "驻马店" ,
    intro : "驻马店人社局"
  },
  {
    name : "许昌" ,
    intro : "许昌市魏都区劳动就业局"
  },
  {
    name : "濮阳" ,
    intro : "濮阳市人社局"
  },
  {
    name : "临沂" ,
    intro : "临沂市人社局"
  },
  {
    name : "中山" ,
    intro : "中山市人社局"
  },
  {
    name : "淮安" ,
    intro : "淮安市清江浦区人社局"
  },
  {
    name : "惠州" ,
    intro : "惠州市惠城区人社局"
  },
  {
    name : "泰州" ,
    intro : "泰州市海陵工业园区人社局"
  },
  {
    name : "温州" ,
    intro : "温州市龙湾区/鹿城区人社局"
  },{
    name : "兴安盟" ,
    intro : "兴安盟就业局"
  },{
    name : "包头" ,
    intro : "昆区人社局" 
  },{
    name : "漳州" ,
    intro : "漳州人社局"
  },{
    name : "宁波" ,
    intro : "鄞州区人社局"
  },{
    name : "太原" ,
    intro : "太原人社局"
  },{
    name : "南昌" ,
    intro : "东湖区人社局"
  }
]

const handleShowTips = (item) => {
  let res = "" ;
  for(let i  in cityName) {
    if(cityName[i].name == item) {
      res = cityName[i].intro ;
    }
  }
  return res ;
}
export default handleShowTips ;